import React from "react";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    label: string,
    correct?: boolean,
}

const TaskGame1: React.FunctionComponent<Props> = () => {

    const data : Item[] = [
        {
            label: 'tam, gdzie jest człowiek - tam jest temat',
            correct: true
        },
        {
            label: 'tematem na reportaż może być wszystko, pod warunkiem, że jest ciekawe',
            correct: true
        },
        {
            label: 'żeby znaleźć dobry temat, trzeba zadać dobre pytanie',
            correct: true
        },
        {
            label: 'reportaż musi dawać do myślenia',
            correct: true
        },
        {
            label: 'jeśli Ciebie coś zaskoczy, to prawdopodobnie zaskoczy też innych',
            correct: true
        },
        {
            label: 'dobry reportaż budzi emocje',
            correct: true
        },
        {
            label: 'nie zadawalajmy się pierwszymi znalezionymi bohaterami i pierwszymi ich odpowiedziami',
            correct: true
        },
        {
            label: 'żeby zweryfikować, czy temat jest ciekawy, warto zapytać o to pięć różnych osób w różnym wieku',
            correct: true
        }
        
    ]

    return (
        <ul className="task-game-1">
            {data.map((i, index) => {
                return (
                    <li key={index}>
                        <label className={`${i.correct? 'correct' : 'wrong'}`}>
                            <input type="checkbox" />
                            <div className="game-element">
                                {i.label}
                            </div>
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}

export default TaskGame1;